import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (duration && onClose) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const typeStyles = {
    success: {
      bg: 'bg-green-500/10 dark:bg-green-500/20',
      border: 'border-green-500/20 dark:border-green-500/30',
      text: 'text-green-600 dark:text-green-400',
      icon: 'check_circle'
    },
    error: {
      bg: 'bg-red-500/10 dark:bg-red-500/20',
      border: 'border-red-500/20 dark:border-red-500/30',
      text: 'text-red-600 dark:text-red-400',
      icon: 'error'
    },
    warning: {
      bg: 'bg-amber-500/10 dark:bg-amber-500/20',
      border: 'border-amber-500/20 dark:border-amber-500/30',
      text: 'text-amber-600 dark:text-amber-400',
      icon: 'warning'
    },
    info: {
      bg: 'bg-blue-500/10 dark:bg-blue-500/20',
      border: 'border-blue-500/20 dark:border-blue-500/30',
      text: 'text-blue-600 dark:text-blue-400',
      icon: 'info'
    }
  };

  const style = typeStyles[type] || typeStyles.success;

  return (
    <div className={`${style.bg} border ${style.border} rounded-lg p-4 flex items-start gap-3 shadow-lg animate-in slide-in-from-top-5 fade-in duration-300`}>
      <span className={`material-symbols-outlined ${style.text} text-xl`}>
        {style.icon}
      </span>
      <div className="flex-1">
        <p className={`${style.text} text-sm font-medium`}>{message}</p>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className={`${style.text} hover:opacity-70 transition-opacity`}
        >
          <span className="material-symbols-outlined text-xl">close</span>
        </button>
      )}
    </div>
  );
};

// Toast Container Component
export const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div className="fixed top-4 right-4 z-[250] flex flex-col gap-2 max-w-md">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
          duration={toast.duration}
        />
      ))}
    </div>
  );
};

export default Toast;
